import { render, staticRenderFns } from "./dualCameraDashboard.vue?vue&type=template&id=3b38f117&scoped=true"
import script from "./dualCameraDashboard.vue?vue&type=script&lang=js"
export * from "./dualCameraDashboard.vue?vue&type=script&lang=js"
import style0 from "./dualCameraDashboard.vue?vue&type=style&index=0&id=3b38f117&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b38f117",
  null
  
)

export default component.exports